import { css } from '@emotion/react';
import { rem } from 'polished';
import {
  borderRadius,
  borderRadiusScaled,
  ComponentColors,
  ComponentSize,
  spacing,
  spacingScaled,
} from '../../foundations';

export const inputFontSizeMap: Record<ComponentSize, string> = {
  small: rem('12px'),
  medium: rem('15px'),
  large: rem('18px'),
};

export const inputLineHeightMap: Record<ComponentSize, string> = {
  small: rem('16px'),
  medium: rem('20px'),
  large: rem('24px'),
};

export const inputFontFamily = 'DM Sans';

export const inputFontWeight = 400;

export const inputFieldPaddingSize = spacing.size3;

export const inputFieldPlaceholderOpacity = 0.6;

/** Text styles for field based input components e.g. TextField, TextArea and Select */
export const getInputFieldFontStyles = ($size: ComponentSize) => css`
  font-size: ${inputFontSizeMap[$size]};
  line-height: ${inputLineHeightMap[$size]};
  font-weight: ${inputFontWeight};
  font-family: ${inputFontFamily};
`;

/** Border and color styles for field based input components e.g. TextField, TextArea and Select */
export const getInputFieldBorderAndColorStyles = (colors: ComponentColors, size: ComponentSize) => css`
  border: ${rem(spacingScaled(spacing.size1, size))} solid ${colors.stroke};
  border-radius: ${rem(borderRadiusScaled(borderRadius.rounded4, size))};
  color: ${colors.on};
  background-color: ${colors.fill};

  :hover {
    background-color: ${colors.fillFeedback};
  }

  :focus-within {
    outline: ${borderRadiusScaled(spacing.size2, size)} solid ${colors.focusRing};
  }
`;
